import { render, staticRenderFns } from "./CleanerDetail.vue?vue&type=template&id=23a420c8"
import script from "./CleanerDetail.vue?vue&type=script&lang=js"
export * from "./CleanerDetail.vue?vue&type=script&lang=js"
import style0 from "./CleanerDetail.vue?vue&type=style&index=0&id=23a420c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports